<template>
  <!-- 検査案件一覧 -->
  <div id="RequestSearch">
    <div id="container">
      <div class="labelTitle lable">検査案件検索</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber"/></td>
            <th>種別</th>
            <td>
              <select v-model="searchConditions.kind">
                <option value="[]"></option>
                <option v-for="item in kindGroupMaster" :key="item.value" :value="item.value">{{item.label}}</option>
              </select>
            </td>
            <th>デモ</th>
            <td>
              <select v-model="searchConditions.demoFlag">
                <option :value="0"></option>
                <option :value="1">含まない</option>
                <option :value="2">デモのみ</option>
              </select></td>
            <th>状態</th>
            <td>
              <select v-model="searchConditions.status">
                <option value= "[]"></option>
                <option v-for="item in statusList" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>進捗状況</th>
            <td>
              <select v-model="searchConditions.progress">
                <option value="[]"></option>
                <option v-for="item in progressList" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
            <th>依頼元</th>
            <td><input type="text" v-model="searchConditions.client"/></td>
            <th>医療機関<br>/企業</th>
            <td><input type="text" v-model="searchConditions.hospital"/></td>
            <th>患者名</th>
            <td><input type="text" v-model="searchConditions.patientName"/></td>
          <tr>
            <th>ブロック</th>
            <td>
              <select v-model="searchConditions.block">
                <option value=""></option>
                <option v-for="item in blockMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
            </td>
            <th>担当支店</th>
            <td>
              <select v-model="searchConditions.branchOfficeCode">
                <option value=""></option>
                <option v-for="item in branchOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
           </td>
            <th>営業所<br>（売上）</th>
            <td>
              <select v-model="searchConditions.salesOfficeCode">
                <option value=""></option>
                <option v-for="item in salesOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
           </td>
            <th>営業担当者</th>
            <td><input type="text" v-model="searchConditions.salesStaffName"/></td>
          </tr>
          <tr>
            <th>依頼日</th>
            <td colspan="3">
                  <input type="date" v-model="searchConditions.applicationDateStart"/>
               ～ <input type="date" v-model="searchConditions.applicationDateEnd"/>
            </td>
            <th>完了日</th>
            <td colspan="3">
                  <input type="date" v-model="searchConditions.completionDateStart"/>
               ～ <input type="date" v-model="searchConditions.completionDateEnd"/></td>
          </tr>
          <tr>
            <th>シリアル</th>
            <td><input type="text" v-model="searchConditions.serial" @keyup.enter="onKeyupEnter()"/></td>
            <th>判定有無</th>
            <td><select id="judgementFlag" v-model="searchConditions.judgementFlag"><option value=""></option><option value="0">無</option><option value="1">有</option></select></td>
            <th>報告書DL<br>(申請者)</th>
            <td><select id="requestDLFlag" v-model="searchConditions.requestDLFlag"><option value=""></option><option value="0">未</option><option value="1">済</option></select></td>
            <th>報告書DL<br>(担当者)</th>
            <td><select id="staffDLFlag" v-model="searchConditions.staffDLFlag"><option value=""></option><option value="0">未</option><option value="1">済</option></select></td>
          </tr>
          <tr>
            <th>HST同梱<br>の有無</th>
            <td>
              <select v-model="searchConditions.hstRequestFlag">
                <option :value="0"></option>
                <option :value="1">有</option>
                <option :value="2">無</option>
              </select>
            </td>
            <th>院内貸出<br>の有無</th>
            <td>
              <select v-model="searchConditions.depositMachineFlag">
                <option :value="0"></option>
                <option :value="1">有</option>
                <option :value="2">無</option>
              </select>
            </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="data.length > 0">
        <div style="float:left">
          <b-button style="margin-right:10px;" class="clipboadCopyButton is-primary" @click="clipboardCopy('requestSearchTable')">クリップボードにコピー</b-button>
          <b-button v-if="!isOpen" @click="isOpen=true" class="is-primary" icon-left="table-column-width" >列選択</b-button>
          <b-button v-if="isOpen" @click="isOpen=false" class="is-primary" icon-left="close-box-outline" >閉じる</b-button>
          <div v-if="isOpen" style="clear:both; height:0px;" >
            <div class="box selectColumn">
              <div style="height:30px;">
                <b-checkbox class="columnCheckBox" v-model="isAllChecked" @input="changeAllCheckBox" >全てチェック</b-checkbox>
                <a style="float:right;" @click="isOpen=false"><b-icon icon="close"/></a>
              </div>
              <b-checkbox class="columnCheckBox" v-model="columns.receiptNumber.checked" @input="changeCheckBox(columns.receiptNumber)" >受付番号</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.kind.checked" @input="changeCheckBox(columns.kind)" >種別</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.officeCode.checked" @input="changeCheckBox(columns.officeCode)" >営業所コード</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.officeName.checked" @input="changeCheckBox(columns.officeName)" >営業所（売上）</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.salesStaff.checked" @input="changeCheckBox(columns.salesStaff)" >営業担当者名</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.client.checked" @input="changeCheckBox(columns.client)" >依頼元</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.hospital.checked" @input="changeCheckBox(columns.hospital)" >医療機関/企業</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.patient.checked" @input="changeCheckBox(columns.patient)" >患者名</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.cvhri.checked" @input="changeCheckBox(columns.cvhri)" >CVHRI</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.hstRequestFlag.checked" @input="changeCheckBox(columns.hstRequestFlag)" >HST同梱の有無</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.status.checked" @input="changeCheckBox(columns.status)" >状態</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.progress.checked" @input="changeCheckBox(columns.progress)" >進捗状況</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.applicationDate.checked" @input="changeCheckBox(columns.applicationDate)" >依頼日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.completionDate.checked" @input="changeCheckBox(columns.completionDate)" >完了日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.requestDLFlag.checked" @input="changeCheckBox(columns.requestDLFlag)" >報告書DL(申請者)</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.staffDLFlag.checked" @input="changeCheckBox(columns.staffDLFlag)" >報告書DL(担当者)</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.inquiry.checked" @input="changeCheckBox(columns.inquiry)" >問い合わせ</b-checkbox>
            </div>
          </div>
        </div>
        <span class="result-count" style="position: relative; top:6px;">件数：{{data.length}}件</span>
        <b-table
          id="requestSearchTable"
          :data="data"
          :paginated="true"
          per-page="100"
          pagination-position="both"
          default-sort="receiptNumber"
        >
          <template slot-scope="props">
            <b-table-column :visible="columns.receiptNumber.checked" field="receiptNumber" label="受付番号" :width="columns.receiptNumber.width" centered sortable>
                <router-link v-if="props.row.type=='kenshin'" :to="{name:'RequesKenshintDetail', params:{item:props.row, searchConditions:searchConditions}}">{{props.row.receiptNumber}}</router-link>
                <router-link v-else :to="{name:'RequestDetail', params:{item:props.row, searchConditions:searchConditions}}">{{props.row.receiptNumber}}</router-link>
            </b-table-column>
            <b-table-column :visible="columns.kind.checked"  field="kind" label="種別" :width="columns.kind.width" sortable>{{getKindGroupLabel(props.row.kind)}}<span v-if="props.row.demo" class="demo"/><span v-if="props.row.depo" class="depo"/></b-table-column>
            <b-table-column :visible="columns.officeCode.checked"  field="salesOfficeCode" label="営業所コード" :width="columns.officeCode.width" centered sortable>{{props.row.salesOfficeCode}}</b-table-column>
            <b-table-column :visible="columns.officeName.checked"  field="salesOfficeCode" label="営業所名" :width="columns.officeName.width" sortable>{{props.row.salesOfficeCode | officeFilter(salesOfficeMaster)}}</b-table-column>
            <b-table-column :visible="columns.salesStaff.checked"  field="salesStaffName" label="営業担当者名" :width="columns.salesStaff.width" sortable>{{props.row.salesStaffName}}</b-table-column>
            <b-table-column :visible="columns.client.checked"  field="client" label="依頼元" :width="columns.client.width" sortable>{{props.row.client}}<span v-if="props.row.proxyFlag" class="agent"/></b-table-column>
            <b-table-column :visible="columns.hospital.checked"  field="hospital" label="医療機関/企業" :width="columns.hospital.width" sortable>{{props.row.hospital}}</b-table-column>
            <b-table-column :visible="columns.patient.checked"  field="patientName" label="患者名" :width="columns.patient.width" sortable>{{props.row.patientName}}</b-table-column>
            <b-table-column v-if="props.row.cvhri!=-1" :visible="columns.cvhri.checked"  field="cvhri" label="CVHRI" :width="columns.cvhri.width" sortable>{{props.row.cvhri}}</b-table-column>
            <b-table-column v-if="props.row.cvhri==-1" :visible="columns.cvhri.checked"  field="cvhri" label="CVHRI" :width="columns.cvhri.width" sortable>算出不可</b-table-column>
            <b-table-column :visible="columns.hstRequestFlag.checked"  field="hstRequestFlag" label="HST同梱の有無" :width="columns.hstRequestFlag.width" sortable><span v-if="props.row.hstRequestFlag == 1">有</span><span v-if="props.row.hstRequestFlag == 2">無</span></b-table-column>
            <b-table-column :visible="columns.status.checked"  field="status" label="状態" :width="columns.status.width" centered sortable>
              <span :class="getTabClass4InternalStatus(props.row.status)">
                {{getStatus(props.row.status)}}
              </span>
            </b-table-column>
            <b-table-column :visible="columns.progress.checked"  field="progress" label="進捗状況" :width="columns.progress.width" centered sortable>
              <span :class="getTabClass4RequestStatus(props.row.status)">
                {{props.row.progress}}
              </span>
            </b-table-column>
            <b-table-column :visible="columns.applicationDate.checked"  field="applicationDate" label="依頼日" :width="columns.applicationDate.width" centered sortable>{{props.row.applicationDate }}</b-table-column>
            <b-table-column :visible="columns.completionDate.checked"  field="completionDate" label="完了日" :width="columns.completionDate.width" centered sortable>{{ props.row.completionDate }}</b-table-column>
            <b-table-column :visible="columns.requestDLFlag.checked"  field="requestDLFlag" label="DL(申請者)" :width="columns.requestDLFlag.width" centered sortable><b-icon v-if="props.row.requestDLFlag" icon="check-bold" /></b-table-column>
            <b-table-column :visible="columns.staffDLFlag.checked"  field="staffDLFlag" label="DL(担当者)" :width="columns.requestDLFlag.width" centered sortable><b-icon v-if="props.row.staffDLFlag" icon="check-bold" /></b-table-column>
            <b-table-column :visible="columns.inquiry.checked"  field="mailto" label="問い合わせ" :width="columns.inquiry.width" centered><a :href="props.row.mailto"><b-icon icon="email-outline" /></a></b-table-column>
          </template>
        </b-table>
      </div>
      <div class="result-area" v-if="dataBlank && data.length == 0">
        <div class="result-count">件数：{{data.length}}件</div>
      </div>
    </div>
  </div>
</template>

<script>
import {requestStatus} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";

export default {
  name: "RequestSearch",
  methods: {
    onKeyupEnter: function(){
      //シリアルを取得
      let serialItems = this.searchConditions.serial.split('/');
      if(serialItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        this.searchConditions.serial = serialItems[1]
      }
    },
    doSearch: function() {
      let isSearchParam = false
      let keys = Object.keys(this.searchConditions)
      for(let i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]] && this.searchConditions[keys[i]] !="[]"){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      if (this.searchConditions.judgementFlag != '' && (this.searchConditions.requestDLFlag != '' || this.searchConditions.staffDLFlag != '')) {
        this.showErrorMessage("判定有無と報告書DL(申請者/担当者)を同時に指定する事はできません。")
        return;
      }
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          let conditionStatus = JSON.parse(_this.searchConditions.status);
          let conditionProgress = JSON.parse(_this.searchConditions.progress);
          var obj = {
            receiptNumber: _this.searchConditions.receiptNumber,
            kind:  JSON.parse(_this.searchConditions.kind),
            demo: _this.searchConditions.demoFlag,
            status: conditionStatus,
            progress: conditionProgress,
            client: _this.searchConditions.client,
            hospital: _this.searchConditions.hospital,
            patientName: _this.searchConditions.patientName,
            block: _this.searchConditions.block,
            branchOfficeCode: _this.searchConditions.branchOfficeCode,
            salesOfficeCode: _this.searchConditions.salesOfficeCode,
            salesStaffName: _this.searchConditions.salesStaffName,
            applicationDateStart: _this.searchConditions.applicationDateStart,
            applicationDateEnd: _this.searchConditions.applicationDateEnd,
            completionDateStart: _this.searchConditions.completionDateStart,
            completionDateEnd: _this.searchConditions.completionDateEnd,
            judgementFlag: _this.searchConditions.judgementFlag,
            requestDLFlag: _this.searchConditions.requestDLFlag,
            staffDLFlag: _this.searchConditions.staffDLFlag,
            serial: _this.searchConditions.serial,
            hstRequestFlag: _this.searchConditions.hstRequestFlag,
            depositMachineFlag: _this.searchConditions.depositMachineFlag
          }
          return client.apis.internalRequestSearch.getRequestListPOST({
            body:obj
          });
        },
        function(result){         
          _this.data = result.obj;
          if(_this.data && _this.data.length > 0){
            var subject = encodeURI("【Philips Care Portal】<ここに件名を記載してください>")
            for(var item of _this.data){
              var body = encodeURI(
                "\n"
                + "【受付番号】" + item.receiptNumber +"\n"
                + "【依頼元】" + _this.escapeStringForMailTo(item.client) +"\n"
                + "【医療機関】" + _this.escapeStringForMailTo(item.hospital) +"\n"
                + "【検査種別】" + _this.getKindGroupLabel(item.kind) +"\n"
                + "\n"
                + "【お問い合わせ内容】\n"
                + "\n"
                + "<ここにお問い合わせ内容を記載してください。>\n"
              );
              item.mailto = "mailto:" + item.clientlMailAddress + "?subject=" + subject + "&body=" + body;
            }
            _this.$nextTick(() => {
              _this.chengeTableWidth(_this.tableWidth);
            })
          }
          _this.dataBlank = true;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    changeCheckBox: function(checkboxModel) {
      var width = checkboxModel.width;
      var tableElement = this.getTableElement();
      var newWidth = 0;
      if (checkboxModel.checked) {
        newWidth = tableElement.clientWidth + width;
      } else {
        newWidth = tableElement.clientWidth - width;
      }
      this.chengeTableWidth(newWidth);
    },
    getTableElement: function(){
      var parentElement = document.getElementById(
        "requestSearchTable"
      );
      return parentElement.getElementsByTagName("table")[0];      
    },
    changeAllCheckBox: function() {
      if(this.isAllChecked){
        this.chengeTableWidth(this.tableWidth);
      } else {
        this.chengeTableWidth(0);
      }
      Object.values(this.columns).map(clumn => clumn.checked = this.isAllChecked)
    },
    chengeTableWidth: function(width){
      var tableElement = this.getTableElement();
      tableElement.style.width = width + "px";
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tableWrapper = btable.getElementsByClassName("table-wrapper")[0];
      var table = tableWrapper.getElementsByTagName("table")[0];
      var tbody = table.getElementsByTagName("tbody")[0];
      var tr = tbody.getElementsByTagName("tr")
      var records = []
      for (let i = 0; i < tr.length ;i++) {
        records.push(tr[i].innerText)
      }
      navigator.clipboard
        .writeText(records.join("\n"))
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
  },
  data() {
    var columns = {
        receiptNumber: { checked: true, width: 100 },
        kind: { checked: true, width: 230 },
        officeCode: { checked: false, width: 120 },
        officeName: { checked: false, width: 160 },
        salesStaff: { checked: false, width: 150 },
        client: { checked: true, width: 300 },
        hospital: { checked: true, width: 300 },
        patient: { checked: true, width: 150 },
        status: { checked: true, width: 100 },
        progress: { checked: true, width: 100 },
        applicationDate: { checked: true, width: 100 },
        completionDate: { checked: true, width: 100 },
        requestDLFlag: { checked: true, width: 100 },
        staffDLFlag: { checked: true, width: 100 },
        inquiry: { checked: true, width: 100 },
        hstRequestFlag: { checked: true, width: 100 },
        cvhri: { checked: true, width: 100 },
      }
    var tableWidth = 0;
    Object.values(columns).map(clumn => {
      if(clumn.checked) tableWidth += clumn.width
    })
    let salesOfficeMaster = this.getSalesOfficeMaster();
    let branchOfficeMaster = this.getBranchOfficeMaster();
    let blockMaster = this.getBlockMaster();
    let kindGroupMaster = this.getKindGroup();
    let statusList = this.getStatusList();
    //川越受付中・判定依頼中・売上計上中を削除する。
    let index = statusList.findIndex( function(item){
      return item.code.includes(requestStatus.kawagoeAcceptance)
    });
    if(index => 0){
      statusList.splice(index, 1);
    }
    index = statusList.findIndex( function(item){
      return item.code.includes(requestStatus.jugdmentRequest)
    });
    if(index => 0){
      statusList.splice(index, 1);
    }
    index = statusList.findIndex( function(item){
      return item.code.includes(requestStatus.salesAppropriation)
    });
    if(index => 0){
      statusList.splice(index, 1);
    }
    let progressList = this.getProgressList();
    let preSearchConditions = this.$route.params["searchConditions"];
    let searchConditions = {
      receiptNumber:"",
      kind:"[]",
      demoFlag: 0,
      hstRequestFlag: 0,
      depositMachineFlag: 0,
      status:"[]",
      progress:"[]",
      client:"",
      hospital:"",
      patientName: "",
      block:"",
      branchOfficeCode: "",
      salesOfficeCode: "",
      salesStaffName: "",
      applicationDateStart:"",
      applicationDateEnd:"",
      completionDateStart:"",
      completionDateEnd:"",
      judgementFlag:"",
      requestDLFlag:"",
      staffDLFlag:"",
      serial:""
    }
    return {
      salesOfficeMaster,
      branchOfficeMaster,
      blockMaster,
      kindGroupMaster,
      statusList,
      progressList,
      preSearchConditions,
      searchConditions,
      data: [],
      isOpen: false,
      isAllChecked: false,
      columns: columns,
      tableWidth : tableWidth,
      atLaunchHidden: atLaunchHidden,
      dataBlank: false
    };
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },  
  },
  components: {},
  mounted: function() {
    if(this.preSearchConditions){
      this.searchConditions = this.preSearchConditions;
      this.doSearch();
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width: 100px;
}
.selectColumn {
  width: 800px;
  position: absolute;
  background-color: white;
  z-index: 25;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/search/RequestSearch.vue